import React from "react";
import styled from "styled-components";


const Button = ({ label,width}) => {
  
  const StyledButton = styled.button`
  background-color: #4caf50;
  width:${width};
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background-color: #45a049;
  }`;


  return <StyledButton>{label}</StyledButton>;
};

export default Button;